import { SrInsightType } from '@plato/data/starrocks/types';

/**
 * Insight types about a category the customer has never purchased — the sales report
 * has no revenue history to show for them, so they get no category link.
 */
export const newCategoryInsightTypes: SrInsightType[] = [
    SrInsightType.CROSS_SELL,
    SrInsightType.INDUSTRY_TOP,
    SrInsightType.GLOBAL_TOP,
];
